import { apiHref } from "@/lib/api";

// Per-device preference: the browser wired to the yard printer opts in; office / email-only sites leave it off.
export const AUTO_PRINT_KEY = "ab_auto_print_docket";
export const autoPrintEnabled = () => localStorage.getItem(AUTO_PRINT_KEY) === "1";
export const setAutoPrint = (on) => localStorage.setItem(AUTO_PRINT_KEY, on ? "1" : "0");

// Call BEFORE awaiting the completion request (keeps the tab inside the user's click so popup blockers allow it).
export function prepareAutoPrintTab() {
  if (!autoPrintEnabled()) return null;
  try { return window.open("", "_blank"); } catch { return null; }
}
export function finishAutoPrint(tab, docket) {
  if (!tab) return;
  if (docket?.id) tab.location.href = apiHref(`/dockets/${docket.id}/pdf`);
  else tab.close();
}
